/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Manages fields, a replacement for JSON Schema.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "icon",
    title: "Icon",
    description: "Selection of an icon from the application's icon set.",
    type: "field",
    use: {
        namespace: "ua.icon"
    },
    tests: {
        valid: {
            must: true,
            run: function () {
                return validate({ title: "Name", type: "string", min: 2, max: 6 }, "Hello");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid String",
            description: "The value must be a string.",
            template: "Expected string but received ${typeof}"
        },
        iconNotFound: {
            title: "Icon Missing",
            description: "The icon you selected is not in this application's icon set.",
            template: "The icon '${icon}' was not found in this application's icon set."
        }
    }
});

var iconSet = require("../.includes/icons.json");

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ typeof: typeof value });
    }

    // Check if the icon exists in the icon set
    if (!iconSet[value.toLowerCase()]) {
        _.errors.iconNotFound.throw({ icon: value });
    }

    
} module.exports.validate = validate;

function ReloadIconSet() {
    // In a real application, this might fetch from a database or external source.
    // Here, we just reload the static JSON file.
    iconSet = require("../.includes/icons.json");
} module.exports.ReloadIconSet = ReloadIconSet;